import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./auth-context";
import { Spinner } from "@/components/ui";

/** Gates the admin console. The route already sits inside <RequireAuth>, so the
 *  session is hydrated here; we only check the admin bit. Non-admins bounce to
 *  the app home. (The backend enforces admin on every endpoint regardless.) */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();

  if (status === "loading") {
    return (
      <div className="flex h-full min-h-screen items-center justify-center text-brand-600">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (!user?.is_admin) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
